export const learnMachineGroupTypes = [
  {
    label: '预进组',
    value: 1
  },
  {
    label: '当前在组',
    value: 2
  },
  // {
  //   label: '已离组',
  //   value: 3
  // }
];
export const learnMachineSmallGroupTypes = [
  {
    label: '当前在组',
    value: 1
  },
  {
    label: '已离组',
    value: 2
  }
];

export const one2oneTypes = [
  {
    label: "在读学生",
    value: 1
  },
  {
    label: "已结课学生",
    value: 2
  },
  {
    label: "未开课学生",
    value: 3
  }
]
export const classListOption = [
    {
      label:'班课',
      value:0
    },
    {
      label: '学习机大组',
      value: 1
    },
    {
      label: '学习机小组',
      value: 2
    },
    {
      label: '个性化',
      value: 3
    }
  ]